<template>
	<div id="cgg_reg" class="comform">
		<form>
			<p><img src="/static/cgglogo.png" /></p>
			<div class="pwd cominpput">
				<span><img src="/static/loph.png" /></span>
				<input type="text" autocomplete="off" name="mobile" id="cid" v-model="cid" placeholder="请输入卡号" />
			</div>
			<div class="conpwd cominpput">
				<span><img src="/static/ys.png" /></span>
				<input type="password" name="rand" autocomplete="off" id="pwd" v-model="pwd" placeholder="请输入密码" class="wid_50" />
			</div>
			<a class="btn" @click="login()">提货登记</a>
		</form>
	</div>
</template>

<script>
import {
  GiftOrder_Verify,
  GiftOrder_Current
} from "@/api/api.js"

export default {
  data () {
    return {
		cid:'',
		pwd:''

    }
  },
  methods:{
	  login:function(){
		  let that = this;
		  GiftOrder_Verify({cardID:that.cid,cardPwd:that.pwd},function(res){
			if(res.code == 200){
				localStorage.setItem("giftsession",res.extand.token);
		  		that.$router.push('giftinfo');
			}
			else{
				that.$message.error(res.message);
			}
		  })
	  },
  },
  created:function(){
	  let that = this;
	  let token = localStorage.getItem("giftsession");
	  if(token) {
	  	GiftOrder_Current({ID:token},function(res){
			  if(res.code == 200){
		  		that.$router.push('giftinfo');
			  }
		});
	  }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>



// WEBPACK FOOTER //
// src/wechat/giftlogin.vue